export class ThematicError extends Error {
  constructor(
    readonly message: string,
    readonly status: number,
    readonly theme: string,
    readonly requestId: string
  ) {
    super(message);
    this.message = message;
    this.theme = theme;
    this.status = status;
    this.requestId = requestId;
  }
}
